var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-publication-guide';
                    var viewUrl = 'sprite.svg#view-icon-publication-guide';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 185 130',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };